// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "textarea[data-v-eed41030]{min-height:100px;border-width:1px}.has-error[data-v-eed41030]{--tw-border-opacity:1;border-color:rgba(217,0,26,var(--tw-border-opacity))}", ""]);
// Exports
module.exports = exports;
